import {
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import Swal from "sweetalert2";
import "./../../bibliotecacomponents/crearSubcategoriaDewey/crearSubcategoriaDewey.css";

export function CreateAuthor({
  onAdd,
  title,
  confirmationText,
  actionFunction,
  isOpen,
  setIsOpen,
  nuevoAutor,
  setNuevoAutor,
}) {
  const handleChange = (e) => {
    setNuevoAutor({ ...nuevoAutor, [e.target.name]: e.target.value });
  };

  const handleCrearAutor = async () => {
    try {
      const autorParaCrear = {
        nombreAutor: nuevoAutor.nombreAutor,
        codigoCutter: nuevoAutor.codigoCutter,
        autorPic: nuevoAutor.autorPic,
      };

      const autorCreado = await actionFunction(autorParaCrear);
      onAdd(autorCreado);
      setIsOpen(false);
      setNuevoAutor({
        nombreAutor: "",
        codigoCutter: "",
        autorPic: "",
      });
      Swal.fire({
        title: "Éxito!",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        text: "El autor se ha guardado con éxito.",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    } catch (error) {
      setIsOpen(false);
      Swal.fire({
        title: "Error!",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        text: "No se pudo guardar el autor.",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    }
  };

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="nombreAutor"
          label="Nombre del Autor"
          type="text"
          fullWidth
          variant="outlined"
          value={nuevoAutor.nombreAutor}
          onChange={handleChange}
        />
        <TextField
          margin="dense"
          name="codigoCutter"
          label="Código Cutter"
          type="text"
          fullWidth
          variant="outlined"
          value={nuevoAutor.codigoCutter}
          onChange={handleChange}
        />
        {nuevoAutor.autorPic && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img
              src={nuevoAutor.autorPic}
              alt="Vista previa de la imagen"
              style={{
                MaxWidth: "100%",
                marginTop: "10px",
                height: "220px",
                justifySelf: "center",
              }}
            />
          </div>
        )}
        <TextField
          margin="dense"
          name="autorPic"
          label="URL de Foto de Perfil"
          type="text"
          fullWidth
          variant="outlined"
          value={nuevoAutor.autorPic}
          onChange={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCrearAutor} color="success">
          {confirmationText}
        </Button>
        <Button
          onClick={() => {
            setIsOpen(false);
          }}
          color="error"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
